export enum HomePageTitlesEnum {
  Jobs = 'Jobs',
  DelegatedJobs = 'Delegated Jobs',
  Projects = 'Projects',
  WorkPackages = 'Work Packages',
  Home = 'Home',
  Tableau = 'Tableau',
}
